import Header, { MenuOptions } from "../../Global/Header/Header";
import EntryDropdown from "./EntryDropdown/EntryDropdown";
import classes from "./Home.module.css";
import Dropdown from "../../Global/customDropdown/Dropdown";
import Footer from "../../Global/Footer/Footer";
import TripCards from "../../Global/Cards/TripCards";
import InfluencerCards from "./InfluencerCards";
import ExplorerReviews from "./ExplorerReviews";
import Svg1 from "./SVG/Svg1";
import Svg2 from "./SVG/Svg2";
import Svg3 from "./SVG/Svg3";
import DesktopCategoryFilter from "../../Global/DesktopCategoryFilter/DesktopCategoryFilter";
import BookExplorationMobile from "./BookExplorationMobile/BookExplorationMobile";
import { useNavigate } from "react-router-dom";
import NewTripCards from "../../Global/Cards/newTripCards";
import { Button } from "../../components/ui/button";

export const HomeView = ({
  tripData,
  influencerData,
  reviewData,
  homePageCards,
  tripMonthHandler,
  tripDataHandler,
  dropdownOptions,
  monthOptionsArr,
  onViewAllClicked,
  selectedCategory
}) => {
  // const [basicModal, setBasicModal] = useState(true);

  // const toggleShow = () => setBasicModal(!basicModal);

  const navigate = useNavigate();

  return (
    <>
      <div className="relative">
        <img
          className="w-full h-136 lg:h-full object-cover"
          src="https://static.wixstatic.com/media/da937f_64755d2bf3844ce9bf015544be9b087b~mv2.jpg/v1/fill/w_1345,h_842,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Untitled%20design%20(12).jpg"
          alt=""
        />
        <div className="absolute top-0 left-0 right-0">
          <Header activeTab={MenuOptions.HOME} />
        </div>
        <div className="w-full absolute top-0 mt-28 lg:mt-44 left-0 right-0">
          <p
            className={
              "w-full font-Aeonik text-xl sm:text-3xl lg:text-6xl text-center md:px-8 sm:px-0"
            }
          >
            Travel <span style={{ color: "#E65439" }}>Influencer</span> Designed{" "}
            <span style={{ color: "#E65439" }}>Itineraries</span>
          </p>
          <p
            className={
              "w-full font-Aeonik text-xs lg:text-lg lg:mt-4 text-center mt-2 px-8"
            }
          >
            Discover places with influencer led tours, offering curated travel
            experiences in India and abroad
          </p>
          <div className="mt-8">
            <EntryDropdown
              monthOptionsArr={monthOptionsArr}
              tripMonthHandler={tripMonthHandler}
            />
          </div>
        </div>
      </div>
      <div className="mt-8">
        <p ref={homePageCards} className={classes["upcoming-explorations"]}>
          <span className={classes["upcoming-text-w"]}>
            Our upcoming popular explorations
          </span>
          <span className={classes["upcoming-text-m"]}>
            Upcoming Explorations
          </span>
        </p>
        <p className={classes["upcoming-explorations-subline"]}>
          {" "}
          Enabling travellers to discover and experience new forms of travelling
        </p>
        {/* 10 underscores used to create a line */}
        <p className={classes["underline"]}>__________</p>
        <div className={classes["filter-display-handler"]}>
          <DesktopCategoryFilter
            tripDataHandler={tripDataHandler}
            tripMonthHandler={tripMonthHandler}
            dropdownOptions={monthOptionsArr}
            selectedCategory={selectedCategory}
          />
        </div>

        <div className={classes["filter-display-handler-1"]}>
          <Dropdown
            tripDataHandler={tripDataHandler}
            options={dropdownOptions}
            plc={"Select Category"}
          />
        </div>
        {/* Filter for trip cards
        <div className={classes['trip-filter']} >

            <div style={{width:"50vw",display:"flex",justifyContent:"space-between",margin:"auto",marginLeft:"1vw"}}>
            <button style={{borderRadius:"100vw",height:"2.5vw",border:"none",backgroundColor:"rgba(13, 7, 20, 0.05)",fontSize:"1vw",paddingLeft:"1vw",paddingRight:"1vw"}}>All</button>
            <button style={{borderRadius:"100vw",height:"2.5vw",border:"none",backgroundColor:"rgba(13, 7, 20, 0.05)",fontSize:"1vw",paddingLeft:"1vw",paddingRight:"1vw"}}>Influencer Curated</button>
            <button style={{borderRadius:"100vw",height:"2.5vw",border:"none",backgroundColor:"rgba(13, 7, 20, 0.05)",fontSize:"1vw",paddingLeft:"1vw",paddingRight:"1vw"}}>International Experiences</button>
            <button style={{borderRadius:"100vw",height:"2.5vw",border:"none",backgroundColor:"rgba(13, 7, 20, 0.05)",fontSize:"1vw",paddingLeft:"1vw",paddingRight:"1vw"}}>Weekend Getaways</button>
            <button style={{borderRadius:"100vw",height:"2.5vw",border:"none",backgroundColor:"rgba(13, 7, 20, 0.05)",fontSize:"1vw",paddingLeft:"1vw",paddingRight:"1vw"}}>Mindful Retreats</button>
            </div>

        </div> */}

        {tripData.length > 0 && <NewTripCards tripData={tripData} />}

        <Button className="w-[80%] md:hidden md:w-[20%] ml-[10%] md:ml-[40%] bg-white border border-black text-black hover:bg-[#e65439] hover:text-white hover:font-bold hover:border-none hover:scale-[1.2] transition-transform duration-[1s] self-center mt-[2vw] mb-[10vw]" onClick={onViewAllClicked}>
          View All
        </Button>

        <button
          onClick={onViewAllClicked}
          className={`${classes["view-all-button"]} hidden md:block`}
        >
          View All
        </button>

        <p className={classes["book-exploration"]}>
          Book your next Exploration in <br className={classes["break"]} />3
          steps
        </p>
        <p className={classes["upcoming-explorations-subline"]}>
          {" "}
          Begin your journey with us today{" "}
        </p>
        <p className={classes["underline"]}>____________</p>

        <div className={classes["svg-container"]}>
          <div className={classes["svg"]}>
            <Svg1 />
            <p className={classes["svg-text"]}>Select Your Exploration</p>
            <p className={classes["svg-subtext"]}>
              {" "}
              Choose your adventure from our curated selection, fill out the
              simple booking form, and let our team guide you through the rest
            </p>
          </div>

          <div className={classes["svg"]}>
            <Svg2 />
            <p className={classes["svg-text"]}>Reserve Your Spot</p>
            <p className={classes["svg-subtext"]}>
              {" "}
              Confirm your presence with a deposit. That’s it. Done. You are all
              set for your adventure
            </p>
          </div>

          <div className={classes["svg"]}>
            <Svg3 />
            <p className={classes["svg-text"]}>Arrive at your destination!</p>
            <p className={classes["svg-subtext"]}>
              {" "}
              Get all excited as now you only have to turn up to your
              destination and make some of the best memories of your life
            </p>
          </div>
        </div>
        <BookExplorationMobile />

        <p className={classes["amazing-influencers"]}>
          Amazing Travel Influencers
        </p>
        <p className={classes["upcoming-explorations-subline"]}>
          Discover their secret spots, travel hacks, and stories that fuel the
          wanderlust within{" "}
        </p>
        <p className={classes["underline"]}>__________</p>

        <InfluencerCards influencerData={influencerData} />

        {reviewData.length > 0 && (
          <>
            <p className={classes["text-happy-explorers"]}>
              Hear from Our Happy Explorers
            </p>
            <p className={classes["underline"]}>__________</p>

            <div className={classes["empty-1"]}></div>

            <ExplorerReviews reviewData={reviewData} />
          </>
        )}

        <div className={classes["travel-influencer-container"]}>
          <img
            className={classes["travel-inf-img"]}
            src="https://static.wixstatic.com/media/da937f_dff43efc1f5649bab5d5db5c19106ed9~mv2.jpg/v1/fill/w_1032,h_301,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Untitled%20design%20(13).jpg"
            alt=""
          />

          <p className={classes["travel-inf-text-1"]}>
            Join as a Travel Influencer
          </p>

          <p className={classes["travel-inf-text-2"]}>
            Collaborate, Inspire and Share
          </p>

          <button
            onClick={() => {
              navigate("/influencer-registration");
            }}
            className={classes["travel-inf-btn"]}
          >
            Host a Trip
          </button>
        </div>
        <Footer />
      </div>
    </>
  );
};
